var _g, _g2, _g3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpenBoxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 41"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#open-box-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CBD5D3",
  d: "M9.437 14.945h37.126l6.109 21.148H3.562z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#open-box-icon_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#A2ACAA",
  d: "M46.561 14.945H9.436V1.316H46.56z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#open-box-icon_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M54.081 24.344v2.846c0 5.305 0 7.487-1.651 9.134s-4.31 1.648-9.627 1.648H13.43c-5.317 0-7.975 0-9.627-1.648s-1.652-3.83-1.652-9.133v-2.612h7.952c1.842 0 3.477.84 4.24 2.513l1.572 3.45a4.7 4.7 0 0 0 4.278 2.748H36.04a4.7 4.7 0 0 0 4.278-2.748l1.572-3.45a4.7 4.7 0 0 1 4.278-2.748z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7BCBC",
  d: "M53.737 24.344h-4.623l-2.551-9.4V1.317zm-44.3-9.399-2.615 9.634H2.189L9.437 1.316z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "open-box-icon_svg__a",
  width: 52.869,
  height: 24.908,
  x: 1.683,
  y: 14.005,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.94
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.94
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_484_13513"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_484_13513",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "open-box-icon_svg__b",
  width: 40.885,
  height: 17.389,
  x: 7.556,
  y: 0.377,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.94
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.94
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_484_13513"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_484_13513",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "open-box-icon_svg__c",
  width: 55.689,
  height: 17.389,
  x: 0.273,
  y: 23.404,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.94
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.94
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_484_13513"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_484_13513",
  result: "shape"
})))));
export default SvgOpenBoxIcon;